import { apiFetch } from '@/api/client'

export type MemberEventRow = {
  id: string
  name: string
  openDate: string | null
  status: 'Enable' | 'Disable'
  isEdit: boolean
}

export type GetAllEnabledEventsResponse = {
  ok?: boolean
  data?: MemberEventRow[]
}

export type ChangeMatchStatusMasterResponse = {
  ok?: boolean
  eventId?: string
  status?: 'Enable' | 'Disable'
}

/** Lab Category.getAllEnabledEvents via hierarchy-service. */
export async function fetchMemberEvents(userId: string): Promise<MemberEventRow[]> {
  const res = await apiFetch<GetAllEnabledEventsResponse>('/v1/catalog/getAllEnabledEvents', {
    method: 'POST',
    body: JSON.stringify({ userId }),
  })
  return Array.isArray(res?.data) ? res.data : []
}

/** Lab Category.changeMatchStatusMaster via hierarchy-service. */
export async function changeMatchStatusMaster(body: {
  eventId: string
  userId: string
  status: 'Enable' | 'Disable'
}): Promise<ChangeMatchStatusMasterResponse> {
  return apiFetch<ChangeMatchStatusMasterResponse>('/v1/catalog/changeMatchStatusMaster', {
    method: 'POST',
    body: JSON.stringify(body),
  })
}
